import { Component, ElementRef, OnInit, ChangeDetectionStrategy } from '@angular/core';
import gsap from 'gsap';
import SplitType from 'split-type';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LoaderComponent implements OnInit {
  constructor(private el: ElementRef) {}

  ngOnInit(): void {
    const masterTimeline = gsap.timeline({ repeat: -1, repeatDelay: 1 });

    const text = SplitType.create('#comp_name');
    masterTimeline.from(text.chars, {
      duration: 0.2,
      opacity: 0,
      y: 10,
      stagger: {
        amount: 0.5,
        each: 0.1,
        from: 'start',
      },
      delay: 0.5,
    });

    const slogan = this.el.nativeElement.querySelector('#comp_slogan');
    masterTimeline.from(slogan, {
      duration: 0.2,
      opacity: 0,
      y: '50%',
      stagger: {
        amount: 0.3,
        each: 0.1,
        from: 'start',
      },
      delay: 0.1,
    });
  }
}
